import { Injectable } from '@angular/core';
import { WebpushUser, PushSubscriptionInt } from '../interfaces/interfaces.index';
import { applicationServerPublicKey } from '../shared/config/config';
import { NotificationService } from './services.index';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationMiddlewareServicesService {
  public pushNotificationStatus = {
    isSubscribed: false,
    isSupported: false,
    isInProgress: false
  };
  private swRegistration: ServiceWorkerRegistration = null;
  public notifications = [];

  constructor(private notificationService: NotificationService) { }

  init() {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      navigator.serviceWorker.register('/assets/sw.js').then(swReg => {
        this.swRegistration = swReg;
        this.checkSubscription();
      }).catch(error => console.error('Service Worker Error', error));
      this.pushNotificationStatus.isSupported = true;
    } else {
      this.pushNotificationStatus.isSupported = false;
    }

    navigator.serviceWorker.addEventListener('message', (event) => this.notifications.push(event.data));
  }

  checkSubscription() {
    this.swRegistration.pushManager.getSubscription().then(subscription => {
      this.pushNotificationStatus.isSubscribed = !(subscription === null);
    });
  }

  toggleSubscription(id: number) {
    (this.pushNotificationStatus.isSubscribed) ? this.unsubscribeUser() : this.subscribeUser(id);
  }

  subscribeUser(id: number) {
    this.pushNotificationStatus.isInProgress = true;
    const applicationServerKey = this.urlB64ToUint8Array(applicationServerPublicKey);
    this.swRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    }).then(subscription => {
      const newSub = JSON.parse(JSON.stringify(subscription));
      const subc: WebpushUser = {
        subscription : {
          auth: newSub.keys.auth,
          p256Dh: newSub.keys.p256dh,
          endPoint: newSub.endpoint
        },
        userId : id
      };
      this.notificationService.callSubscribe(subc).subscribe(() => this.pushNotificationStatus.isSubscribed = true);
    }).catch(err => console.log('Failed to subscribe the user: ', err)).then(() => {
      this.pushNotificationStatus.isInProgress = false;
    });
  }

  unsubscribeUser() {
    this.pushNotificationStatus.isInProgress = true;
    let sub;
    this.swRegistration.pushManager.getSubscription().then((subscription) => {
      if (subscription) {
        sub = JSON.parse(JSON.stringify(subscription));
        return subscription.unsubscribe();
      }
    }).catch((error) => console.log('Error unsubscribing', error)).then(() => {
      this.notificationService.unsubscribe({
        auth: sub?.keys.auth,
        p256Dh: sub?.keys.p256dh,
        endPoint: sub?.endpoint
      } as PushSubscriptionInt).subscribe(() => {
        this.pushNotificationStatus.isSubscribed = false;
        this.pushNotificationStatus.isInProgress = false;
      });
    });
  }

  urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

}
